import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import {
  cloudMessagingProviders,
  ExternalScannerModule,
  InputScannerModule,
  IntegratedScannerModule,
  NfcReaderModule,
  ScannerModule,
  SOFTLINE_CONFIG_APP_INFO,
} from '@softline/application';
import {
  browserCloudMessagingProviders,
  BrowserModule,
  browserNfcReaderProviders,
  Html5ScannerModule,
} from '@softline/browser';
import { version } from '../../../../version';
import { customerConfig } from '../customer-config';

export const providePlatform = (
  environment: any
): Array<Provider | EnvironmentProviders> => {
  const providers: Array<Provider | EnvironmentProviders> = [
    importProvidersFrom(
      BrowserModule.forRoot(),
      ScannerModule.forRoot(),
      InputScannerModule.forRoot(),
      Html5ScannerModule.forRoot(),
      ExternalScannerModule.forRoot(),
      IntegratedScannerModule.forRoot(),
      NfcReaderModule.forRoot()
    ),
    ...browserNfcReaderProviders,
    {
      provide: SOFTLINE_CONFIG_APP_INFO,
      useValue: {
        ...customerConfig,
        version: version,
      },
    },
  ];

  if (customerConfig.oneSignalAppId) {
    providers.push(
      ...cloudMessagingProviders({
        oneSignalAppId: customerConfig.oneSignalAppId,
      }),
      ...browserCloudMessagingProviders
    );
  }

  return providers;
};
